<template>
  <div class="card-model">
    <v-card elevation="0" color="transparent" class="pa-0">
      <v-card-text class="pa-0">
        <v-layout align-center justify-center>
          <v-card
            class="mt-2"
            style="
              transform: scale(0.9);
              border: 1px solid #0003;
              position: relative;
              z-index: 1;
              max-width: 575px;
            "
          >
            <v-card-text>
              <v-card-subtitle class="pa-0 pb-5">
                <v-layout justify-space-between align-center>
                  <div>
                    <v-img
                      :src="cliente.imgLogo || $store.state.imgLogoDefault"
                      width="100"
                    />
                  </div>
                  <div
                    class="font-weight-bold font-italic"
                    style="font-size: 18px"
                  >
                    Life Card
                  </div>
                </v-layout>
              </v-card-subtitle>
              <v-row>
                <v-col>
                  <v-row>
                    <v-col cols="12">
                      <v-chip
                        small
                        class="py-6 ml-n2"
                        color="transparent"
                        style="width: 100%"
                      >
                        <v-layout column>
                          <v-layout align-center>
                            <div>{{ $t("Nome") }}</div>
                            <v-icon
                              v-show="
                                isChipMouseOver === 0 &&
                                !$vuetify.breakpoint.mobile
                              "
                              class="ml-1"
                              >mdi-pencil</v-icon
                            >
                          </v-layout>
                          <v-layout
                            style="font-size: 18px"
                            class="font-weight-bold"
                          >
                            {{ getData({ field: "nome", type: "string" }) }}
                          </v-layout>
                        </v-layout>
                      </v-chip>
                      <v-divider class="red lighten-2 my-2"></v-divider>
                    </v-col>

                    <v-col cols="12" md="9">
                      <v-row>
                        <div
                          class="pl-2 d-flex flex-row flex-wrap justify-start"
                        >
                          <v-layout
                            align-center
                            justify-start
                            v-for="(item, i) in dataCard"
                            :key="i + 1"
                            class="mb-4 flex-grow-0"
                          >
                            <v-chip
                              v-if="item.show"
                              small
                              class="py-6 overflow-visible"
                              color="transparent"
                              :text-color="getStyleChip(i + 1).textColor"
                              :dark="isChipMouseOver === i + 1"
                              @click="onShowModal(i)"
                              @mouseover="onChipMouseOver(i + 1)"
                              @mouseleave="onChipMouseLeave(i + 1)"
                            >
                              <v-layout column>
                                <v-layout align-center>
                                  <div>{{ $i18n.t(dataCard[i].text) }}</div>
                                  <v-icon
                                    v-if="
                                      isChipMouseOver === i + 1 &&
                                      !$vuetify.breakpoint.mobile
                                    "
                                    class="pl-1"
                                    >mdi-pencil</v-icon
                                  >
                                  <div class="pl-1" v-else>&nbsp;&nbsp;</div>
                                </v-layout>
                                <v-layout style="font-size: 16px">
                                  <div
                                    :class="
                                      $vuetify.breakpoint.md
                                        ? 'text-wrap'
                                        : 'text-no-wrap'
                                    "
                                  >
                                    {{ getData(item) }}
                                  </div>
                                </v-layout>
                              </v-layout>
                            </v-chip>
                          </v-layout>
                        </div>

                        <v-col class="d-block d-md-none">
                          <v-layout class="justify-center justify-md-end">
                            <div>
                              <div class="d-flex justify-center">
                                <div
                                  style="border: dotted 1pt #999"
                                  v-if="qrCodeImageStatus === 1"
                                  class="
                                    d-flex
                                    justify-center
                                    flex-column
                                    align-center
                                  "
                                >
                                  <div class="ma-3">
                                    {{ $i18n.t("carregando_qr_code") }}
                                  </div>
                                  <v-progress-circular
                                    indeterminate
                                    width="2"
                                    size="24"
                                    class="mb-3"
                                  />
                                </div>
                                <div
                                  style="border: dotted 1pt #999"
                                  v-else-if="
                                    qrCodeImageStatus === -1 ||
                                    (qrCodeImageStatus === -1 && !qrCodeImage)
                                  "
                                  class="caption red--text lighten-1"
                                >
                                  <div class="ma-3">
                                    {{ $i18n.t("erro_carregar_imagem") }}
                                  </div>
                                </div>
                                <v-img
                                  v-else
                                  :width="$vuetify.breakpoint.xs ? 120 : 150"
                                  aspect-ratio="1"
                                  :src="`data:image/png;base64, ${qrCodeImage}`"
                                />
                              </div>
                            </div>
                          </v-layout>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="d-none d-md-block">
                      <v-row class="fill-height">
                        <v-col class="fill-height pa-0">
                          <v-layout
                            class="justify-center justify-md-end"
                            fill-height
                            align-center
                          >
                            <div class="d-flex justify-center">
                              <div
                                style="border: dotted 1pt #999"
                                v-if="qrCodeImageStatus === 1"
                                class="
                                  d-flex
                                  justify-center
                                  flex-column
                                  align-center
                                  mr-5
                                "
                              >
                                <div class="ma-3">
                                  {{ $i18n.t("carregando_qr_code") }}
                                </div>
                                <v-progress-circular
                                  indeterminate
                                  width="2"
                                  size="24"
                                  class="mb-3"
                                />
                              </div>
                              <div
                                style="border: dotted 1pt #999"
                                v-else-if="
                                  qrCodeImageStatus === -1 ||
                                  (qrCodeImageStatus === -1 && !qrCodeImage)
                                "
                                class="caption red--text lighten-1"
                              >
                                <div class="ma-3">
                                  {{ $i18n.t("erro_carregar_imagem") }}
                                </div>
                              </div>
                              <v-img
                                v-else
                                :width="$vuetify.breakpoint.xs ? 120 : 150"
                                aspect-ratio="1"
                                :src="`data:image/png;base64, ${qrCodeImage}`"
                              />
                            </div>
                          </v-layout>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: [
    "dataCard",
    "isChipMouseOver",
    "getData",
    "getStyleChip",
    "onShowModal",
    "onChipMouseOver",
    "onChipMouseLeave",
    "showModalExport",
    "exportCard",
    "cliente",
    "qrCodeImageStatus",
    "qrCodeImage",
  ],
};
</script>

<style lang="scss"></style>
